import AppRouter from "./router";
import { AuthProvider } from "./auth/AuthContext";
import { ensureHub } from "@hub";
import "./styles/theme.css";
import "./styles/site.css";
import "./styles/manuals.css";
import "./styles/home.css";
import "./styles/beta.css";
import "./styles/sales-demo.css";
import "@tour/sales-tour.css";

ensureHub();

export default function App() {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}
